var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"white--text font-weight-bold caption text-uppercase text-center state-chip",attrs:{"color":_vm.chipClass},domProps:{"innerHTML":_vm._s(_vm.$t(`appointments.statuses-short.${_vm.chipLabel}`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }